<template>
  <!-- footer 开始 -->
  <div class="footer">
    <div class="w">
      <!-- <div class="service"> -->
      <!-- <video controls>
          <source
            src="https://lianyueit-shop.oss-cn-qingdao.aliyuncs.com/video/sf-video.943b9b9f.mp4"
            type="video/mp4"
          />
        </video> -->
      <!-- <ul>
          <li><i>多</i>品类齐全，轻松购物</li>
          <li><i>快</i>多仓直发，极速配送</li>
          <li><i>好</i>正品行货，精致服务</li>
          <li><i>省</i>天天低价，畅选无忧</li>
        </ul> -->
      <!-- </div> -->
      <div class="help">
        <dl>
          <dt>关于我们</dt>
          <dd><a href="/about/gaikuang">集团概况</a></dd>
          <dd><a href="/about/chuangshiren">创始人</a></dd>
          <dd><a href="/about/wenhua">企业文化</a></dd>
          <dd><a href="/about/rongyu">企业荣誉</a></dd>
          <dd><a href="/about/licheng">发展历程</a></dd>
        </dl>
        <dl>
          <dt>三发资讯</dt>
          <dd><a href="/list/1">公司新闻</a></dd>
          <dd><a href="/list/2">项目新闻</a></dd>
          <dd><a href="/list/3">行业新闻</a></dd>
          <dd><a href="/list/4">公益新闻</a></dd>
        </dl>
        <dl>
          <dt>三发集团</dt>
          <dd><a href="/project">公司项目</a></dd>
          <dd><a href="/join">加入三发</a></dd>
          <dd><a href="/contact">联络三发</a></dd>
        </dl>
        <dl>
          <dt>党建引领</dt>
          <dd>党建动态</dd>
          <dd>党建新闻</dd>
          <dd>党建学习</dd>
          <dd>组织建设</dd>
        </dl>
        <dl>
          <dt>联系我们</dt>
          <dd>山东省济南市</dd>
          <dd><a href="tel:0531-88511999">0531-88511999</a></dd>
          <dd><a href="tel:4007779119">400-777-9119</a></dd>
        </dl>
        <!-- <dl>
            <dt>友情链接</dt>
            <dd>
              <a href="http://shuiyunju.sanfajituan.com/m" target="_blank"
                >水云居</a
              >
            </dd>
            <dd>
              <a href="http://www.4007779119.com" target="_blank">五指红茶业</a>
            </dd>
          </dl> -->
      </div>
      <div class="copyright">
        <div class="fl">
          版权所有：三发集团 Copyright ©2012-2027 Sanfa Real Estale Co.,Ltd
        </div>
        <div class="fr">
          <img
            src="@/assets/beian.png"
            alt="鲁公网安备37010202001948"
            style="width: 15px; height: 15px"
          />
          <a
            href="https://beian.mps.gov.cn/#/query/webSearch?code=37010202001948"
            rel="noreferrer"
            target="_blank"
            style="margin-right: 15px; margin-left: 5px"
            >鲁公网安备37010202001948</a
          >
          <a href="https://beian.miit.gov.cn" target="_blank"
            >鲁ICP备11021138号</a
          >
          <span @click="drawer = true"> 法律声明</span>
        </div>
      </div>
      <!-- 法律声明 -->
      <el-drawer
        ref="drawer"
        :with-header="false"
        :visible.sync="drawer"
        :show-close="true"
        direction="btt"
        size="80%"
      >
        <div class="drawer-container">
          <div class="legal">
            <div class="legal-left">
              <i
                class="el-icon-circle-close"
                @click="$refs.drawer.closeDrawer()"
                style="font-size: 65px"
              ></i>
            </div>
            <div class="legal-right">
              法律声明 LEGAL INFORMATION
              本网站(www.sanfazhiye.com)为版权人所有的文件，在此并未作任何授权。网站上的文件仅限于为信息和非商业或个人之目的使用，并且不得在任何网络计算机上复制或公布，也不得在任何媒体上传播。未经版权人许可，任何人不得擅自使用。
              否则版权人将依法追究其法律责任。 免责声明
              版权人拥有对本网站的内容进行随时更改之权利，是前将不会另行通知。版权人不保证或声明本网站展示的资料是否正确、全面或是最新数据。本网站内的所有图片、模型、文字描述等，仅作参考信息，非开发商的任何承诺或要约。
              开发商声明
              网站有关其开发项目信息的介绍，均以政府最后审批文件为准。商品房买卖双方之间的关系以当事人签订的买卖双方之间的关系以当事人签订买卖合同为准。任何人因本网站或依赖其内容进行交易所引致的损失，开发商均不承担任何责任。
              隐私权政策
              我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。我们不会将Cookie用于本政策所述目的之外的任何用途。
              您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。
              如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。
              如需详细了解如何更改浏览器设置，请访问各浏览器官方网站的介绍页面。
              三发集团
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
  <!-- footer 结束 -->
</template>
<script>
export default {
  name: "HomeFooter",
  data() {
    return {
      drawer: false,
    };
  },
};
</script>
<style lang="scss" scoped>
// .footer {
//   height: 885px;
// }
// video {
//   width: 100%;
//   height: 600px;
// }
.el-drawer {
  background: #000;
  .drawer-container {
    background: #000;
    margin: 0 auto;
    // width: 80%;
  }
  .legal {
    height: 100%;
    padding: 20px 10%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    .legal-left {
      flex: 2;
    }
    .legal-right {
      flex: 5;
      text-align: left;
    }
  }
}
</style>
